module.exports = __webpack_public_path__ + "static/img/tabela.f63e620.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/frutuba_tubaina/tabela.png
// module id = nket
// module chunks = 0